const validate = (values) => {
  const errors = {}
  const requiredFields = [
    'newPassword',
    'confirmPassword'
  ]

  requiredFields.forEach((field) => {
    if (!values[ field ]) {
      if(field === "confirmPassword"){
        errors[ field ] = `Please enter confirm password`
      }
      else{
        errors[ field ] = `Please enter password`
      }
    }
  })
  if(values.confirmPassword !== values.newPassword){
    errors.confirmPassword = 'Password does not match'
  }
  return errors
}

export default validate



// WEBPACK FOOTER //
// ./src/views/ResetPassword/validate.js